import { IGameState } from '../../Game/IGameState';
import { showPrioPopup } from '../../UI/UIStateHelper';
import Game from '../../../Game';

export function toggleNotification(
    state: IGameState,
    notifications: number
): IGameState {
    if (!window.navigator.onLine) {
        return {
            ...state,
            UIStatePrio: showPrioPopup(state.UIStatePrio, 'errorMenu', {
                title: Game.locale.getText('AndroidConnectionError'),
                body: Game.locale.getText('AndroidInternet'),
            }),
        };
    }
    Game.sdk.driver.subscribeToNotifications(!!notifications);
    return {
        ...state,
        playerState: {
            ...state.playerState,
            pushNotifications: notifications,
        },
    };
}
